import React from "react";
import cn from "classnames";
import { FormattedMessage, useIntl } from "react-intl";

import { timeago } from "../../../common/parameters";

import { profilePictureHost } from "../../paths";
import routing from "../../routing";
import Icon from "../../icon";

import { StyledUser, Username, UserImage, UserText, Time } from "./styles";
import { IProps } from "./interfaces";

const User = ({ user, reversed, huge, noTab }: IProps) => {
    const { locale } = useIntl();
    if (user === "anonymous") {
        return (
            <StyledUser
                tabIndex={noTab ? -1 : undefined}
                className={cn({ Reversed: reversed, Disabled: typeof user === "string" })}
                to={"/"}
            >
                <UserText reversed={!!reversed}>
                    <Username className={cn({ Huge: huge })}>Anonymous</Username>
                </UserText>
                <UserImage className={cn({ Huge: huge })}>
                    <Icon i="user" />
                </UserImage>
            </StyledUser>
        )
    }
    return (
        <StyledUser
            tabIndex={noTab ? -1 : undefined}
            className={cn({ Reversed: reversed, Disabled: typeof user === "string" })}
            to={"/" + routing.teacher + "/" + user.username}
        >
            <UserText reversed={!!reversed}>
                <Username className={cn({ Huge: huge })}>{user.displayName || "Anonymous"}</Username>
                {user.created && (
                    <Time>
                        <FormattedMessage
                            id="user.useAgo"
                            values={{ ago: timeago.format(user.created, locale) }}
                        />
                    </Time>
                )}
            </UserText>
            <UserImage className={cn({ Huge: huge })}>
                {user.profilePicture ? (
                    <img src={profilePictureHost + user.profilePicture + ".jpg"} alt="profile" />
                ) : (
                    <Icon i="user" />
                )}
            </UserImage>
        </StyledUser>
    );
}

export default User;
